import en from './countries/en'

export default {
  en
}
